var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.623 36.863L447.623 452.86C446.123 462.594 440.248 471.078 431.655 475.907C426.811 478.625 421.405 480 415.998 480C411.811 480 407.655 479.188 403.686 477.532L281.045 426.432L230.186 502.719C226.321 508.518 219.813 512 212.842 512C201.33 512 191.998 502.668 191.998 491.156V394.98C191.998 387.864 194.37 380.952 198.739 375.335L415.998 96.004L122.332 360.302L19.686 317.533C8.436 312.845 0.811 302.158 0.061 289.986S5.53 266.268 16.123 260.221L464.123 4.223C474.811 -1.886 487.998 -1.324 498.123 5.629S513.498 24.723 511.623 36.863Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.2cbbef248fc5e4f512776e8754f9c615.svg";
export { ForwardRef as ReactComponent };